export default __webpack_public_path__ + "static/feature_analytics_1024-ddd978ebde1aee3e868f8e76ac2de78a.png";